import { pillars } from '@/content/site'
import { Icon } from '@/components/Icon'
import styles from './Pillars.module.css'

export function Pillars() {
  return (
    <section id="que-encuentras" className="section">
      <div className="container">
        <header className={`${styles.head} reveal`}>
          <p className="eyebrow">¿Qué puedo encontrar aquí?</p>
          <h2 className="section-title">Tres caminos para avanzar</h2>
          <p className="section-lead">
            Contenidos y experiencias para personas que quieren crecer y para organizaciones que
            quieren equipos más fuertes.
          </p>
        </header>

        <div className={styles.grid}>
          {pillars.map((p) => (
            <article key={p.key} className={`${styles.card} reveal`}>
              <h3 className={styles.title}>{p.title}</h3>
              <ul className={styles.tags}>
                {p.tags.map((t) => (
                  <li key={t}>{t}</li>
                ))}
              </ul>
              <p className={styles.text}>{p.text}</p>
              <a href={p.href} className="arrow-link">
                {p.cta}
                <Icon name="arrow" size={18} />
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
